(function() {
'use strict';

angular
    .module('TR')
    .service('hotelCoordinates', hotelCoordinates);

function hotelCoordinates(
    $http,
    hotelSearch,
    currentDestination,
    broker,
    objectTypeService,
    fieldGroupService,
    $routeParams,
    $q
) {
    const url = '/api/hotels/availability/';
    const staticUrl = '/api/hotels/static/';
    const service = {
            getCoordinates
        };
    const fields = 'Hotels.Id,Hotels.Latitude,Hotels.Longitude';
    let coordsCache = {};
    const fieldTypes = fieldGroupService.getFieldTypes();
    const fieldFlags = fieldGroupService.getFieldGroup(fieldTypes.Global);

    // Cache invalidation on hotel list change
    broker.subscribe('hotelCoordinates', 'hotelListUpdated', () => coordsCache = {});

    function getCoordinates(searchId) {
        function removeUnmappedHotels(data) {
            if (data == null) {
                return null;
            }
            data.Hotels = _.filter(data.Hotels, hotel => hotel.Latitude || hotel.Longitude);
            return data;
        }

        let promise;
        if (searchId == null) {
            return currentDestination.getCurrentDestination().then(function(dest) {
                promise = $q.when();
                if (dest) {
                    const objectTypeAndId = objectTypeService.getObjectTypeAndId(dest);

                    const cacheKey = `${objectTypeAndId.Type}_${objectTypeAndId.Id}`;

                    if (coordsCache[cacheKey]) {
                        return coordsCache[cacheKey];
                    }

                    promise = $http.post(`${staticUrl}gethotelsbydestination?fields=${fields}`, {
                        DestinationType: objectTypeAndId.Type,
                        DestinationId: objectTypeAndId.Id,
                        DomainId: TRPCONFIG.Domain.DomainId,
                        CultureCode: TRPCONFIG.Domain.CultureCode,
                        FilterCriteria: hotelSearch.getUserSelectedFilterCriteria(),
                        FieldFlags: fieldFlags
                    }, { ignoreErrors: true }).then(function(res) {
                        return removeUnmappedHotels(res.data);
                    });

                    coordsCache[cacheKey] = promise;
                }

                return promise;
            });
        }

        if (coordsCache[searchId]) {
            return coordsCache[searchId];
        }

        promise = $http.post(`${url}gethotels?fields=${fields}`, {
            AvailabilitySearchId: searchId,
            CultureCode: TRPCONFIG.Domain.CultureCode,
            CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
            TripId: $routeParams.tripId,
            FilterCriteria: hotelSearch.getUserSelectedFilterCriteria(),
            FieldFlags: fieldFlags
        }, { ignoreErrors: true }).then(function(res) {
            return removeUnmappedHotels(res.data);
        });

        coordsCache[searchId] = promise;
        return promise;
    }

    return service;
}
})();
